import React from "react"
import { Checkbox } from "material-ui"
import strings from "../../localization/strings"
import { EDayOfWeek } from "../../models"
import { EnumValues } from "enum-values"

interface IProps {
  specifyDays: EDayOfWeek[]
  handleChange(specifyDays: EDayOfWeek[]): void
  readonly:boolean
}

const SpecifyDays: React.SFC<IProps> = (props: IProps) => {
  const allDays: EDayOfWeek[] = EnumValues.getValues(EDayOfWeek)

  const checkedAll = (specifyDays: EDayOfWeek[]) => {
    if (allDays.length !== specifyDays.length) {
      return false
    }
    const sortedArr1 = allDays.slice().sort()
    const sortedArr2 = specifyDays.slice().sort()
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false
      }
    }
    return true
  }

  return (
    <div>
      <Checkbox
        data-intercom-target={"Specify_Days_Select_All"}
        label={strings.SelectAll}
        style={{ width: 100 }}
        labelStyle={{ width: null }}
        iconStyle={{ marginRight: 5 }}
        checked={checkedAll(props.specifyDays)}
        onCheck={(e, value) => props.handleChange(value ? allDays : [])}
        disabled={props.readonly}
      />
      {allDays.map(day =>
        <Checkbox
          key={day}
          data-intercom-target={`SpecifyDays_Select_Day${day}`}
          checked={props.specifyDays.includes(day)}
          label={strings[`${EnumValues.getNameFromValue(EDayOfWeek, day)}_ShortTerm`]}
          onCheck={(e, checked) => {
            let specifyDays = props.specifyDays.slice()
            if (checked) {
              !specifyDays.includes(day) && specifyDays.push(day)
            }
            else {
              specifyDays = specifyDays.filter(item => item !== day)
            }
            props.handleChange(specifyDays)
          }}
          iconStyle={{ marginRight: 5 }}
          style={{ width: 60, marginRight: 10, display: "inline-block" }}
          labelStyle={{ width: null }}
          disabled={props.readonly}
        />
      )}
    </div>
  )
}

export default SpecifyDays